/**
 * @file FooterShowRow.tsx
 * @description Строка «что показывать» вкладки «Подвал» (phase19.16 Р1;
 * SB14, SB21; uiux-design-r1 §2): флажок с подписью, пустое значение —
 * строка неактивна и ведёт его задать («Задать →»), иначе «Изменить →».
 */

import type { ReactNode } from "react";
import { Link } from "react-router";

import { CheckRow } from "../CheckRow";

interface Props {
  label: ReactNode;
  /** Значение для показа; null — не задано (флажок неактивен). */
  value: string | null;
  checked: boolean;
  onChange: (on: boolean) => void;
  /** Куда идти править. */
  edit: string;
}

export function FooterShowRow({ label, value, checked, onChange, edit }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-x-3">
      <CheckRow checked={checked && value !== null} disabled={value === null} onChange={onChange}>
        {label}
        {value === null ? <span className="text-on-surface-variant"> — не задано</span> : null}
      </CheckRow>
      <Link to={edit} className="type-caption inline-flex min-h-12 items-center font-medium text-primary hover:underline">
        {value === null ? "Задать →" : "Изменить →"}
      </Link>
    </div>
  );
}
